import EditorCanvasComponent from "./editorCanvasComponents/EditorCanvasComponent";
import EditorToolbarComponent from "./editorToolbarComponents/EditorToolbarComponent";
import "../editorStyleSheet.css";
import PropTypes from "prop-types";
import React, {useState, useEffect} from 'react';
import SummaryIcon from '@mui/icons-material/Description';
import TranslationIcon from '@mui/icons-material/Translate';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import SpeechIcon from '@mui/icons-material/KeyboardVoice';
import CircularIntegration from "../../../components/SoftProgress/CircularIntegration";
import {Box} from '@mui/material';
import {io} from "socket.io-client";

const BodyComponents = ({
                            handleFullScreen,
                            isFullScreen,
                            mediaPath,
                            containerWidth,
                            numPages,
                            pages,
                            pageNumber,
                            setForcePageNumber,
                            configWidth,
                            setNotification,
                            articleId,
                            digitizationId,
                            zoom,
                            setZoom,
                            selectedWordBbox,
                            pdfDimensions,
                            addOrUpdatePages,
                            fetchData,
                            setHoveredChunkId,
                            hoveredChunkId,
                            page
                        }) => {
    const [brightness, setBrightness] = useState(0);
    const [contrast, setContrast] = useState(0);
    const [activeServices, setActiveServices] = useState({});
    const [displayServicesStatus, setDisplayServicesStatus] = useState(true);

    let bodyWidth = "55%"
    if (configWidth) {
        bodyWidth = `calc(100% - ${configWidth}px)`;
    }

    useEffect(() => {
        if (digitizationId) {
            const baseURL = window?.appConfig?.REACT_APP_SOCKET_SERVER || process.env.REACT_APP_SOCKET_SERVER;
            const socket = io(baseURL, { path: "/socket.io" });
            const eventName = `service_update-${digitizationId}`;

            socket.on(eventName, (res) => {
                const { service, status } = res;
                setDisplayServicesStatus(true)

                if (service) {
                    setActiveServices(prev => ({
                        ...prev,
                        [service]: status
                    }));
                }

                if (res.status === 'Completed') {
                    fetchData()
                    setNotification({
                        show: true,
                        snackbarMessage: res?.message,
                        severity: "success",
                    });
                    setDisplayServicesStatus(false)
                } else if(res.status === 'Error') {
                    setNotification({
                        show: true,
                        snackbarMessage: res?.message,
                        severity: "error",
                    });
                }

            });

            return () => socket.off(eventName);
        }
    }, [digitizationId]);


    return (
        <div style={{width: bodyWidth}}>
            <EditorToolbarComponent
                pageNumber={pageNumber}
                numPages={numPages}
                setForcePageNumber={setForcePageNumber}
                handleFullScreen={handleFullScreen}
                isFullScreen={isFullScreen}
                setNotification={setNotification}
                articleId={articleId}
                zoom={zoom}
                setZoom={setZoom}
                brightness={brightness}
                setBrightness={setBrightness}
                contrast={contrast}
                setContrast={setContrast}
            />
            <EditorCanvasComponent
                mediaPath={mediaPath}
                containerWidth={containerWidth}
                pages={pages}
                setForcePageNumber={setForcePageNumber}
                zoom={zoom}
                setZoom={setZoom}
                brightness={brightness}
                contrast={contrast}
                pageNumber={pageNumber}
                selectedWordBbox={selectedWordBbox}
                pdfDimensions={pdfDimensions}
                addOrUpdatePages={addOrUpdatePages}
                setHoveredChunkId={setHoveredChunkId}
                hoveredChunkId={hoveredChunkId}
                page={page}
            />

            {displayServicesStatus && <Box
                sx={{
                    position: 'fixed',
                    bottom: 20,
                    left: 0,
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    gap: 2,
                    zIndex: 1000,
                }}
            >
                {Object.entries(activeServices).map(([serviceName, status]) => {
                    let Icon;
                    switch (serviceName) {
                        case "Summary":
                            Icon = SummaryIcon;
                            break;
                        case "Translation":
                            Icon = TranslationIcon;
                            break;
                        case "Bookmarking":
                            Icon = BookmarkIcon;
                            break;
                        case "Text to Speech":
                            Icon = SpeechIcon;
                            break;
                        default:
                            return null;
                    }
                    return (
                        <CircularIntegration
                            key={serviceName}
                            Icon={Icon}
                            status={status}
                        />
                    );
                })}
            </Box>}


        </div>

    );


}

BodyComponents.propTypes = {
    mediaPath: PropTypes.string,
    containerWidth: PropTypes.string,
    digitizationId: PropTypes.number,
    fetchData: PropTypes.func,
    zoom: PropTypes.number,
    setZoom: PropTypes.func,
    numPages: PropTypes.number,
    pageNumber: PropTypes.number,
    articleId: PropTypes.number,
    setScale: PropTypes.func,
    configWidth: PropTypes.string,
    handleFullScreen: PropTypes.func,
    setNotification: PropTypes.func,
    isFullScreen: PropTypes.bool,
    pages: PropTypes.array,
    setForcePageNumber: PropTypes.func,
    selectedWordBbox: PropTypes.array,
    addOrUpdatePages: PropTypes.func,
    pdfDimensions: PropTypes.object,
    setHoveredChunkId: PropTypes.func,
    hoveredChunkId: PropTypes.string,
    page: PropTypes.object,
};

export default BodyComponents;